<template>
    <div class="page">
        <div class="page-content">
            <div class="bank-page">
                <div class="bd-desc">
                    <div class="bd-logo"><img src=""></div>
                    <h3 class="bd-title">交通银行</h3>
                    <p class="bd-text">交通银行信用卡官方网站在线申请秒开卡！额度高！免息期长！积分多！消费立享秒减优惠！优逸白金信用卡首年免年费，尊享5积分兑换好礼，“最红星期五”邀您享受便捷的优惠，感受多元化体验，联合多家知名餐饮超市加油品牌，周五买单消费即享优惠五折起！</p>
                    <ul class="d-cd-desc">
                        <li><p class="p1">白金卡</p><p class="p2">卡片级别</p></li>
                        <li><p class="p1">56天</p><p class="p2">最长免息期</p></li>
                        <li><p class="p1">银联</p><p class="p2">发卡组织</p></li>
                        <li class="jj"><p class="p1">110.00元</p><p class="p2">奖金</p></li>
                    </ul>
                </div>
                <ul class="remen-card">
                    <li class="flex item b-line" v-for="item in cardList" @click="$router.push('/card/detail')">
                        <div class="l-bbb"><img src="../assets/images/cd-card.png"/></div>
                        <div>
                            <h4>{{item.name}}</h4>
                            <p class="p1">{{item.desc}}</p>
                            <p class="tags">
                                <a v-for="tag in item.tags">{{tag}}</a>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <toolBar type="list"></toolBar>
    </div>
</template>
<script>
import toolBar from '../components/toolBar.vue'
export default {
    components: {
        toolBar
    },
    data () {
        return {
            cardList: [{
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }]
        }
    }
}
</script>
